export const parseLocale = (locale: string) =>
  locale ? (['deformal', 'de_DE', 'de'].includes(locale) ? 'de' : 'en') : 'de';
